import { FC } from 'react'

import styled from 'styled-components'

import { FileInput } from 'src/Components/FileInput'
import { colors } from 'src/Helpers/constants.ts'

const PhotosSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const PhotosLabel = styled.span`
  font-size: 12px;
  color: ${colors.thirdGray};
`

const PhotosGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const PhotoThumb = styled.div`
  position: relative;
  width: 64px;
  height: 64px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid ${colors.secondGray};
  }
`

const RemovePhotoButton = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background-color: ${colors.red};
  color: white;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

interface PhotoGalleryProps {
  title: string
  addLabel: string
  images: Array<{ id: number; url: string }>
  onAdd: (files: File[]) => void
  onDelete: (imageId: number) => void
}

export const PhotoGallery: FC<PhotoGalleryProps> = ({
  title,
  addLabel,
  images,
  onAdd,
  onDelete,
}) => (
  <PhotosSection data-testid='photo-gallery'>
    <PhotosLabel>{title}</PhotosLabel>
    {images.length > 0 && (
      <PhotosGrid>
        {images.map((image) => (
          <PhotoThumb key={image.id}>
            <img src={image.url} alt='' />
            <RemovePhotoButton type='button' onClick={() => onDelete(image.id)}>
              ×
            </RemovePhotoButton>
          </PhotoThumb>
        ))}
      </PhotosGrid>
    )}
    <FileInput
      label={addLabel}
      placeholder='Выберите фото'
      accept='image/*'
      multiple
      value={[]}
      onChange={(files: File[] | null) => {
        if (files && files.length > 0) onAdd(files)
      }}
    />
  </PhotosSection>
)
